<div class="border px-3"><parameter-formular :data="model" :config="fieldsReadonly" :show-readonly="true"></parameter-formular></div>